import shop from '~/lib/api/shop';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function deleteBasket(reference: string | undefined) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop.delete(getUrl(`/baskets/${reference}`)).json<string>();
}
